'use client';
var classes = {"eyeDropperIcon":"m-b077c2bc","colorPreview":"m-c5ccdcab","dropdown":"m-5ece2cd7"};

export { classes as default };
//# sourceMappingURL=ColorInput.module.css.mjs.map
